export default __webpack_public_path__ + "static/v2-food-logo-e1441793316533cf624ee67ac6a482f5.png";